module.exports = __webpack_public_path__ + "static/media/Sub-2-By-Laws-Westbriar-Village.7b7965de.pdf";